// work data

export const Work = [
    {
        id:1,
        name:"World Clock",
        description:"A real-time clock that lets you track the current time across all time zones, anytime, anywhere.",
        tags:["js","css","html","API"],
        
        demo:"https://parisa-singh.github.io/world-clock/",
        github:"https://parisa-singh.github.io/world-clock/"
    },
    {
        id:2,
        name:"Snake Game Recreated",
        description:"A recreation of the classic snake game with basic graphics using JS, CSS and HTML.",
        tags:["js","css","html","graphics"],
        
        demo:"https://parisa-singh.github.io/snake/",
        github:"https://parisa-singh.github.io/snake/"
    },
    {
        id:3,
        name:"Amherst Map",
        description:"An interactive map of Amherst, MA, featuring location search and 3D view functionality using Google Maps API.",
        tags:["js","css","html","GoogleMapsAPI"],
        
        demo:"https://parisa-singh.github.io/amherst-map/",
        github:"https://parisa-singh.github.io/amherst-map/"
    },
    {
        id:4,
        name:"Simple To-Do List",
        description:"A simple and aesthetic To-Do List app with add, edit, and delete functionalities, powered by JavaScript and localStorage.",
        tags:["js","css","html","localStorage"],
        
        demo:"https://parisa-singh.github.io/to-do-list/",
        github:"https://parisa-singh.github.io/to-do-list/"
    },
    {
        id:5,
        name:"Color Picker",
        description:"A color picker app that allows users to select colors from an image and copy their HEX codes, with zoom and responsive design features.",
        tags:["js","css","html","hex"],
        
        demo:"https://parisa-singh.github.io/color-picker/",
        github:"https://parisa-singh.github.io/color-picker/"
    },
    {
        id:6,
        name:"CSS Hovering Buttons Showcase",
        description:"A simple and visually appealing website showcasing a variety of buttons when hovered over has unique hover animations.",
        tags:["css","hoveringeffects","buttons"],
        
        demo:"https://parisa-singh.github.io/hovering-buttons-showcase/",
        github:"https://parisa-singh.github.io/hovering-buttons-showcase/"
    },
    {
        id:7,
        name:"Dynamic Weather Website",
        description:"A dynamic weather website that brings the world's climate to life with real-time updates and immersive backgrounds for every weather condition.",
        tags:["js","css","html","dynamic","OpenWeatherAPI"],
        
        demo:"https://parisa-singh.github.io/weather/",
        github:"https://parisa-singh.github.io/weather/"
    },
    {
        id:8,
        name:"WebPage Development: Personal Website",
        description:"It is built in React JS using JavaScript, CSS and HTML.",
        tags:["react","js","web-dev"],
        
        demo:"https://parisa-singh.github.io/resume-website/",
        github:"https://parisa-singh.github.io/resume-website/"
    },
    {
        id:9,
        name:"Personal Finance Manager",
        description:"A finance manager locally on your desktop. I used Tkinter in Python to build this manager.",
        tags:["python","tkinter","management-system"],
        
        demo:"https://github.com/parisa-singh/personal-finance-manager",
        github:"https://github.com/parisa-singh/personal-finance-manager"
        
    },
    {
        id:10,
        name:"Proximity Camera Development",
        description:"Developed a surveillance system to detect suspicious behavior related to sexual assault using Raspberry Pi and integrated AWS cloud for secure data storage.",
        tags:["raspberry-pi","aws-cloud","python"],
        
        demo:"https://github.com/parisa-singh/hello-world/blob/main/404.html",
        github:"https://github.com/parisa-singh/hello-world/blob/main/404.html"
        
    },
    {
        id:11,
        name:"Python Games",
        description:"Created desktop games using Python.",
        tags:["python","games"],
        
        demo:"https://github.com/stars/parisa-singh/lists/python-games",
        github:"https://github.com/stars/parisa-singh/lists/python-games"
    },
    {
        id:12,
        name:"Pasword Generator",
        description:"A python tool used to generate a unique, unidentifiable password for you.",
        tags:["python","passwords",],
        
        demo:"https://github.com/parisa-singh/password_generator",
        github:"https://github.com/parisa-singh/password_generator"
       
    },{
        id:13,
        name:"Chipotle Order Processor",
        description:"An automated invoice generation system for Chipotle food orders using Python.",
        tags:["python","automation",],
        
        demo:"https://github.com/parisa-singh/hello-world/blob/main/404.html",
        github:"https://github.com/parisa-singh/hello-world/blob/main/404.html"
        
    },

] 